import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { CompanyDetailsComponent } from '../company-details.component';

@Component({
  selector: 'app-add-branches',
  templateUrl: './add-branches.component.html',
  styleUrls: ['./add-branches.component.scss']
})
export class AddBranchesComponent implements OnInit {

  @Input() companyId: any

  @ViewChild('closeBtn') closeBtn: ElementRef;

  addBranchForm: FormGroup;
  missingFieldMsg = false;

  constructor(private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private companyDetails: CompanyDetailsComponent, private appComp: AppComponent ) { }

  ngOnInit(): void {
    this.addBranchForm = this.formBuilder.group({
      name: ["", Validators.required],
      contact: ["", Validators.required],
      address1: ["", Validators.required],
      address2: [""],
      city: ["", Validators.required],
      state: ["", Validators.required],
      zip: ["", Validators.required],
      phone: ["", Validators.required],
      email: ["", Validators.required],
      contactPhone: ["", Validators.required],
      contactEmail: ["", Validators.required],
      active: [null],
    });
  }

  addBranch(){
    this.appComp.loading = true;
    this.missingFieldMsg = false;
    if (this.addBranchForm.invalid) {
      this.missingFieldMsg = true;
      this.appComp.loading = false;
      return;
    }
    let formObj = this.addBranchForm.getRawValue();
    console.log(formObj);
    formObj.active = true;
    formObj.idCompany = this.companyId;
    this.authService.addBranch(formObj).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.companyDetails.getBranches(this.companyId);
      this.appComp.loading = false;
    }, err =>{
      console.log(err);
      this.appComp.loading = false;
    })
  }

}
